export default __webpack_public_path__ + "static/media/logoutdashboard.ecc7894e.svg";